import { Alert, AlertProps } from "@heroui/react";
import React from "react";

export type LimeAlertProps = AlertProps & {
  message?: string | React.ReactNode | null;
  children?: React.ReactNode;
};

export const LimeAlert = React.forwardRef(
  (
    {
      message,
      classNames = {},
      children,
      color = "danger",
      ...props
    }: LimeAlertProps,
    ref: React.Ref<HTMLDivElement>,
  ) =>
    message || props.title || props.description ? (
      <div className={props.className}>
        <Alert
          ref={ref}
          {...props}
          color={color}
          classNames={{
            ...classNames,
          }}
          title={props.title ?? message}
        >
          {children}
        </Alert>
      </div>
    ) : undefined,
);
LimeAlert.displayName = "LimeAlert";
